/**
 * Status mixin.
 * @example
 * export default {
 *     mixins: [withStatus('not-ready')],
 *
 *     mounted() {
 *         this.setStatus('ready');
 *     },
 * };
 */
export default function withStatus(defaultStatus = 'loading') {
    return {
        data() {
            return {
                mixinStatus: defaultStatus,
            };
        },

        methods: {
            /**
             * Get status.
             * @return {*}
             */
            getStatus() {
                return this.mixinStatus;
            },

            /**
             * Return true if status === given status.
             * @param status
             * @return {boolean}
             */
            isStatus(status) {
                return this.mixinStatus === status;
            },

            /**
             * Set status and fire event/data if needed.
             * @param status
             * @param fireEvent
             * @param fireData
             */
            setStatus(status, fireEvent = false, fireData = null) {
                this.mixinStatus = status;

                if (fireEvent) {
                    this.$emit(status, fireData);
                }
            },
        },
    };
};
